// Shared with order favorites (order-favorites actions) and product favorites (create-order actions)
export enum FavoriteActionMode {
    Add = 'patch',
    Remove = 'delete'
}
